import {GetModelDetailNewsError} from './GetModelDetailNewsError.js'
import {GetVehicleNewsError} from './GetVehicleNewsError.js'
import {GetNewsDetailError} from './NewsDetailError.js'
import {SubscribeToNewsletterError} from './SubscribeToNewsletterError.js'
import {SubscribeToNewsletterWithoutEmailError} from './SubscribeToNewsletterWithoutEmailError.js'

export class NewsErrorsFactory {
  static getModelDetailNewsError = ({message}) => new GetModelDetailNewsError(message)

  static getVehicleNewsError = ({message}) => new GetVehicleNewsError(message)
  static getNewsDetailError = ({message}) => new GetNewsDetailError(message)
  static getSubscribeToNewsletterError = ({message}) => new SubscribeToNewsletterError(message)

  static getSubscribeToNewsletterWithoutEmailError = ({message}) => new SubscribeToNewsletterWithoutEmailError(message)
}
